'use client'

import { forwardRef, HTMLAttributes } from 'react'
import clsx from 'classnames'
import { motion } from 'framer-motion'
import { useAppearance } from '@/shared/utils'
import { variantsHeadline } from '@/shared/constants/variants'
import style from './rich-text.module.scss'

interface RichTextProps extends HTMLAttributes<HTMLDivElement> {
  text: string
}

export const RichText = forwardRef<HTMLDivElement, RichTextProps>((props, ref) => {
  const { className, text } = props
  const { ref: innerRef, animate } = useAppearance(ref)

  return (
    <motion.div
      ref={innerRef}
      animate={animate}
      variants={variantsHeadline}
      className={clsx(style.container, className, 'text text_color_dark richText')}
      dangerouslySetInnerHTML={{ __html: text ?? '' }}
    />
  )
})

RichText.displayName = 'RichText'
